export default function getIn(object, keyPath) {
  return keyPath.reduce((obj, prop) => obj?.[prop], object);
}
